var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-list container"},[_c('h1',{staticClass:"purple"},[_vm._v("\r\n        שיעורי "+_vm._s(_vm.heading)+"\r\n    ")]),_vm._v(" "),_c('videos',{attrs:{"videos":_vm.videosToView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }